/*
Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
*/
/** Start the clipboard write during the click, before a sharing API resolves.
 * WebKit accepts a promised ClipboardItem payload but rejects a delayed write. */
export async function copyShareLink(link: Promise<string>): Promise<void> {
  if (navigator.clipboard?.write && typeof ClipboardItem !== "undefined") {
    const payload = link.then(
      (value) => new Blob([value], { type: "text/plain" }),
    );
    // A constructor/permission failure must not leave an unhandled API rejection.
    void payload.catch(() => {});
    const item = new ClipboardItem({ "text/plain": payload });
    await navigator.clipboard.write([item]);
    return;
  }
  const value = await link;
  if (!navigator.clipboard?.writeText) throw new Error("Clipboard unavailable");
  await navigator.clipboard.writeText(value);
}
